import ErrorHandler from '@module/error-handler';
import ActionHelper from '@module/redux-actions';

import API from '@app/api';

export const actions = ActionHelper.types(['RECEIVED_TRANSFERS_SUCCESS']);

export default ActionHelper.generate({
  list() {
    return async (dispatch) => {
      try {
        const response = await API.TransfersReceived.getReceivedTransfers();

        dispatch({
          type: actions.RECEIVED_TRANSFERS_SUCCESS,
          list: response.body || [],
        });
      } catch (error) {
        ErrorHandler.track(error);
      }
    };
  },
});
